import React from 'react';
import Svg from '@justgiving/svg';
import styles from './IconLabel.scss';

interface IconLabelProps {
  icon: string;
  label: string | JSX.Element;
}

const IconLabel: React.FunctionComponent<IconLabelProps> = ({
  icon,
  label,
}) => (
  <div className="jg-space-mbxs jg-space-mbsm@xl jg-space-mbn jg-space-mtxs jg-space-mtsm@xl jg-display-flex">
    <div className={`jg-text--medium-light ${styles.label}`}>
      <Svg markup={icon} className={styles.icon} />
      {label}
    </div>
  </div>
);

export default IconLabel;
